import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import AuthAggregate from '../aggregate/auth-aggregate';
import { DocAdvancedPrivilege } from '../value-object/doc-advanced-privilege';
import { DocPrivilege } from '../value-object/doc-privilege';
import { tryCatchHandler } from '../../base/decorators';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
import { getPrivilegeAttributesByBasicClientVars, getPrivilegeAttributesByClientVars, } from './utils/generate-doc-privilege';
var AuthDomainService = /** @class */ (function () {
    function AuthDomainService(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
        this.isInitedByBasicClientVars = false;
        this.authAggregate = new AuthAggregate(docMetaDomainService, networkRequestService);
        if (window.basicClientVars) {
            this.initWithBasicClientVars(window.basicClientVars);
        }
    }
    AuthDomainService.prototype.updateWithClientVars = function (clientVars) {
        var _a;
        if (this.isInitedByBasicClientVars) {
            return;
        }
        var privilegeAttributes = getPrivilegeAttributesByClientVars(clientVars);
        this.authAggregate.authInfoEntity.selfDocPrivilege = new DocPrivilege(privilegeAttributes);
        this.authAggregate.authInfoEntity.isOwner = clientVars.isOwner;
        this.authAggregate.authInfoEntity.isAdmin = (_a = clientVars.isAdmin) !== null && _a !== void 0 ? _a : false;
        this.authAggregate.authInfoEntity.selfRole = clientVars.rightFlag;
        this.authAggregate.authInfoEntity.documentPrivilege = clientVars.policy;
        this.authAggregate.authInfoEntity.selfDocAdvancedPrivilege = new DocAdvancedPrivilege({
            readerCanComment: clientVars.advPolicy.reader_can_comment,
            viewForbidCopyPrint: clientVars.advPolicy.view_forbid_copy_print,
            writerCanComment: clientVars.advPolicy.writer_can_comment,
        });
    };
    AuthDomainService.prototype.init = function (requestParam) {
        return __awaiter(this, void 0, void 0, function () {
            var docId, resData, docData, privilegeAttribute, advPolicy;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.isInitedByBasicClientVars) {
                            return [2 /*return*/];
                        }
                        docId = requestParam.docId;
                        return [4 /*yield*/, this.authAggregate.authInfoEntity.fetchAuthInfoData(docId)];
                    case 1:
                        resData = (_e.sent()).resData;
                        docData = resData === null || resData === void 0 ? void 0 : resData.data.data;
                        privilegeAttribute = docData.privilegeAttribute, advPolicy = docData.advPolicy;
                        this.authAggregate.authInfoEntity.isOwner = (_a = docData.isOwner) !== null && _a !== void 0 ? _a : false;
                        this.authAggregate.authInfoEntity.isAdmin = (_b = docData.isAdmin) !== null && _b !== void 0 ? _b : false;
                        this.authAggregate.authInfoEntity.selfRole = (_c = docData.rightFlag) !== null && _c !== void 0 ? _c : 0;
                        this.authAggregate.authInfoEntity.documentPrivilege = (_d = docData.policy) !== null && _d !== void 0 ? _d : 0;
                        // TODO: @mingqiuliao 以下这种初始化的方式，在后台协议有新增权限字段的时候会遗漏，建议跟后台协议对齐，这里不要额外自己定义类型
                        this.authAggregate.authInfoEntity.selfDocPrivilege = new DocPrivilege(__assign(__assign({}, privilegeAttribute), { canFeedback: privilegeAttribute === null || privilegeAttribute === void 0 ? void 0 : privilegeAttribute.canSpitSlot, isPrivilegeExpired: !!docData.privilegeExpire }));
                        this.authAggregate.authInfoEntity.selfDocAdvancedPrivilege = new DocAdvancedPrivilege({
                            readerCanComment: advPolicy === null || advPolicy === void 0 ? void 0 : advPolicy.reader_can_comment,
                            viewForbidCopyPrint: advPolicy === null || advPolicy === void 0 ? void 0 : advPolicy.view_forbid_copy_print,
                            writerCanComment: advPolicy === null || advPolicy === void 0 ? void 0 : advPolicy.writer_can_comment,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 根据 basicClientVars 初始化 authAggregate 数据
     * @param basicClientVars window.basicClientVars
     */
    AuthDomainService.prototype.initWithBasicClientVars = function (basicClientVars) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        if (!basicClientVars.authInfo)
            return;
        var privilegeAttributes = getPrivilegeAttributesByBasicClientVars(basicClientVars);
        this.authAggregate.authInfoEntity.isOwner = (_b = (_a = basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.isOwner) !== null && _b !== void 0 ? _b : false;
        this.authAggregate.authInfoEntity.isAdmin = (_d = (_c = basicClientVars.docInfo) === null || _c === void 0 ? void 0 : _c.isAdmin) !== null && _d !== void 0 ? _d : false;
        this.authAggregate.authInfoEntity.selfRole = (_f = (_e = basicClientVars.authInfo) === null || _e === void 0 ? void 0 : _e.privilegeFlag) !== null && _f !== void 0 ? _f : 0;
        this.authAggregate.authInfoEntity.documentPrivilege = (_j = (_h = (_g = basicClientVars.authInfo) === null || _g === void 0 ? void 0 : _g.privilegeInfo) === null || _h === void 0 ? void 0 : _h.uint32Policy) !== null && _j !== void 0 ? _j : 0;
        this.authAggregate.authInfoEntity.selfDocPrivilege = new DocPrivilege(privilegeAttributes);
        this.authAggregate.authInfoEntity.selfDocAdvancedPrivilege = new DocAdvancedPrivilege({
            readerCanComment: (_m = (_l = (_k = basicClientVars.authInfo) === null || _k === void 0 ? void 0 : _k.privilegeInfo) === null || _l === void 0 ? void 0 : _l.advPolicy) === null || _m === void 0 ? void 0 : _m.readerCanComment,
            viewForbidCopyPrint: (_q = (_p = (_o = basicClientVars.authInfo) === null || _o === void 0 ? void 0 : _o.privilegeInfo) === null || _p === void 0 ? void 0 : _p.advPolicy) === null || _q === void 0 ? void 0 : _q.viewForbidCopyPrint,
            writerCanComment: (_t = (_s = (_r = basicClientVars.authInfo) === null || _r === void 0 ? void 0 : _r.privilegeInfo) === null || _s === void 0 ? void 0 : _s.advPolicy) === null || _t === void 0 ? void 0 : _t.writerCanComment,
        });
        this.isInitedByBasicClientVars = true;
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuthDomainService.prototype, "init", null);
    __decorate([
        tryCatchHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuthDomainService.prototype, "initWithBasicClientVars", null);
    AuthDomainService = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], AuthDomainService);
    return AuthDomainService;
}());
export { AuthDomainService };
